// @ts-nocheck
// import React, { Fragment, useState } from 'react';
// import ExtraInformationBuilderUpdate from '../../../ExtraInformationBuilder/Update/ExtraInformationBuilderUpdate';
// import useAddUpdateExtraInformation from '../../../ExtraInformationBuilder/useAddUpdateExtraInformation';
// import { Form } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// // import Loader from '@components/Shared/Loader/Loader';
// import { useSelector } from 'react-redux';
// import { ntxAPI } from '@API/axiosNeatex';
// import showConfirmation from '@components/Shared/Alert/Confirmation';

// const UpdateExtraRecord = props => {
//   const { extraInformationId, ReferenceId, setRefreshData, setExtraInformationId } = props;

//   const { t, i18n } = useTranslation();

//   const [extraInfoFormData, setExtraInfoFormData] = useState({});
//   const { AddUpdateExtraInformation } = useAddUpdateExtraInformation();
//   const { loading, error } = useSelector(state => state.ExtraInformation);

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isDeletting, setIsDeletting] = useState(false);

//   const handleAddUpdateExtraInfo = async e => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     try {
//       const response = await AddUpdateExtraInformation(extraInfoFormData);

//       if (!response) {
//         CustomAlert({
//           action: 'Error',
//           msg: i18n.language === 'en' ? 'Update failed. Please try again.' : 'فشل التحديث. يرجى المحاولة مرة أخرى.'
//         });
//         return;
//       }

//       CustomAlert({
//         action: 'Edit',
//         msg: i18n.language === 'en' ? 'Data updated successfully' : 'تم تحديث البيانات بنجاح'
//       });
//     } catch (error) {
//       CustomAlert({
//         action: 'Error',
//         msg: i18n.language === 'en' ? 'An error occurred during update.' : 'حدث خطأ أثناء التحديث.'
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleDeleteRecord = async id => {
//     const messages = {
//       confirm:
//         i18n.language === 'en' ? 'Are you sure you want to delete this record?' : 'هل أنت متأكد من حذف هذا السجل؟',
//       success: i18n.language === 'en' ? 'Record deleted successfully' : 'تم حذف السجل بنجاح'
//     };

//     showConfirmation(messages.confirm, async () => {
//       try {
//         setIsDeletting(true);
//         const { data } = await ntxAPI.post(`ExtraInformation/DeleteExtraInformation?ExtraInformationId=${id}`);

//         if (data?.succeeded) {
//           CustomAlert({ action: 'Delete', msg: messages.success });
//           setExtraInformationId(null);
//           setRefreshData(true);
//         } else {
//           CustomAlert({ action: 'Error' });
//         }
//       } catch (err) {
//         CustomAlert({ action: 'Error' });
//       } finally {
//         setIsDeletting(false);
//       }
//     });
//   };
//   return (
//     <Fragment>
//       <Form onSubmit={handleAddUpdateExtraInfo}>
//         <ExtraInformationBuilderUpdate
//           extraInformationId={extraInformationId}
//           setExtraInfoFormData={setExtraInfoFormData}
//           referenceId={ReferenceId}
//         />
//         {loading || error ? null : (
//           <div className='text-end mt-2'>
//             <button type='submit' className='btn me-1 btn-theme ' disabled={isSubmitting || isDeletting}>
//               {isSubmitting ? (
//                 <div className='spinner-border spinner-border-sm me-1'></div>
//               ) : (
//                 <i className='fa fa-save fa-fw me-1'></i>
//               )}
//               {t('Save')}
//             </button>

//             <button
//               onClick={() => handleDeleteRecord(extraInformationId)}
//               type='button'
//               className='btn  btn-danger'
//               disabled={isDeletting || isSubmitting}
//             >
//               {isDeletting ? (
//                 <div className='spinner-border spinner-border-sm'></div>
//               ) : (
//                 <i className='fas fa-trash-alt fa-fw me-1'></i>
//               )}
//               {i18n.language === 'en' ? 'Delete Record' : 'حذف السجل'}
//             </button>
//           </div>
//         )}
//       </Form>
//     </Fragment>
//   );
// };

// export default UpdateExtraRecord;

import ExtraInformationBuilderUpdate from '../../../ExtraInformationBuilder/Update/ExtraInformationBuilderUpdate';

const UpdateExtraRecord = ({ extraInformationId, ReferenceId, setExtraInfoFormData }) => {
  return (
    <>
      <ExtraInformationBuilderUpdate
        extraInformationId={extraInformationId}
        setExtraInfoFormData={setExtraInfoFormData}
        referenceId={ReferenceId}
      />
    </>
  );
};

export default UpdateExtraRecord;
